import { Ng2StateDeclaration, StateService } from "@uirouter/angular";
import { StorageService } from "app/commons/services/storageService.service";

//NOTE: In this case another solution is to use only one state with optional data parameter redirecting to itself with the data parameter.
// for the sake of simplicity and separation of concerns principle I will use two states for the moment
export const GetTokenStateDeclaration: Ng2StateDeclaration = {
  name: 'gettoken',
  url: "/token",
  resolve: {
    token: [
      StorageService,
      StateService,
      function (storage: StorageService, $state: StateService) {
        const token = storage.get.token();
        $state.go('token', {'data': token}, { reload: true });
      }],
  },
}

export const TokenStateDeclaration: Ng2StateDeclaration = {
  name: 'token',
  url: "/token?{data}",
  resolve: {
    token: [
      '$transition$',
      function ($transition$: { params: () => {data: string}; }) {
        const data = $transition$.params().data;
        console.log('token>>>',data);
      }],
  },
}
